var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-page-manage-events-view-manager" }, [
    _c("div", { staticClass: "events-found marginLeft24px" }, [
      _vm._v(_vm._s(_vm.getTotal || 0) + _vm._s(_vm.textPlus) + " EVENTS FOUND")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "list-event-manage-by-date-container" },
      [
        _vm._l(_vm.getEvents, function(item, index) {
          return _c("div", [
            _c("div", { staticClass: "cheetah-digital marginLeft24px" }, [
              _c("span", [_vm._v(_vm._s(item.clientName))])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-cards-wrapper" },
              _vm._l(item.events, function(event, index) {
                return _c("EventCard", {
                  key: index,
                  attrs: { event: event, isNoTrans: index % 3 == 2 }
                })
              })
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clear-both" })
          ])
        }),
        _vm._v(" "),
        _c(
          "infinite-loading",
          {
            ref: "infiniteLoading",
            attrs: { distance: 100 },
            on: { infinite: _vm.infiniteHandler }
          },
          [
            _c("Spinner", { attrs: { slot: "spinner" }, slot: "spinner" }),
            _vm._v(" "),
            _c("div", {
              staticClass: "infinite-status-prompt",
              attrs: { slot: "no-more" },
              slot: "no-more"
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "infinite-status-prompt",
              attrs: { slot: "no-results" },
              slot: "no-results"
            })
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c00da7fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c00da7fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/manage/Manage.vue
// module id = 1793
// module chunks = 1